// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"225":"rooms","854":"widgets"}[chunkId] + "." + {"225":"e61f5720","854":"e6e190c0"}[chunkId] + ".css";
};